import {
  dadataToken
} from './const';

export function initMailSuggestions(tagName) {

  $(document).ready(function () {
    const elem = $(tagName);

    elem.suggestions({
      token: dadataToken,
      type: 'EMAIL',
      hint: false,
      scrollOnFocus: false,
      // eslint-disable-next-line camelcase
      suggest_local: false
    });
  });
}
